import { render } from "./header_toolbar.vue?vue&type=template&id=4640d85f"
import script from "./header_toolbar.vue?vue&type=script&lang=js"
export * from "./header_toolbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__